<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-5">
      <h4 class="mb-0">Parser Yönetimi</h4>
    </div>

    <v-tabs v-model="tab" color="primary" class="mb-4">
      <v-tab value="pipeline">Pipeline</v-tab>
      <v-tab value="chunks">Chunk Yönetimi</v-tab>
      <v-tab value="stats">İstatistikler</v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item value="pipeline">
        <PipelinePanel />
      </v-window-item>
      <v-window-item value="chunks">
        <ChunksPanel />
      </v-window-item>
      <v-window-item value="stats">
        <StatsPanel />
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import PipelinePanel from '@/components/Apps/ParserAdmin/PipelinePanel.vue'
import ChunksPanel from '@/components/Apps/ParserAdmin/ChunksPanel.vue'
import StatsPanel from '@/components/Apps/ParserAdmin/StatsPanel.vue'

const tab = ref('pipeline')
</script>
